// plugins/vue-plyr.js
import Vue from 'vue'
import VuePlyr from 'vue-plyr'

// Importa o CSS do Plyr
import 'vue-plyr/dist/vue-plyr.css'

// Registra o plugin do vue-plyr
Vue.use(VuePlyr, {
  plyr: {
    // Opções padrão do Plyr
  },
  // emit: ['ended']
})
